import * as Raven from 'raven-js';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { environment } from '../../../environments/environment';

import { NotificationsService } from '../notifications/notifications.service';
import { HttpErrorResponse } from '@angular/common/http';
// import { ToastrService } from 'ngx-toastr';


//import { LoggingService } from '../services';
//import * as StackTrace from 'stacktrace-js';

Raven
    .config('https://816a419945484fb6bc896fdd094d1eb0@sentry.io/237538')
    .install();



@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private injector: Injector) { }

    handleError(error: any): void {

        if (environment.production) {
            Raven.captureException(error);
        }

        const notificationsService = this.injector.get(NotificationsService);
        //const loggingService = this.injector.get(LoggingService);

        const location = this.injector.get(LocationStrategy);
        const message = error.message ? error.message : error._body.toString();
        const url = location instanceof PathLocationStrategy
            ? location.path() : '';

        let apiError = this.parseError(error);
        let unwrappedError = error.originalError || error;

        if (!environment.production) {
            this.showErrorInConsole(unwrappedError);
            this.showApiErrorInConsole(apiError);
        }

        // Send Notification to user
        //notificationsService.notify('error', 'Error Log', 'testing');
        //  setTimeout(() => notificationsService.notify('error', 'Error', apiError.message), 1);
        
        // setTimeout(() => toastrService.error(apiError.message, 'Error'), 1);



        // get the stack trace, lets grab the last 10 stacks only
        // StackTrace.fromError(error).then(stackframes => {

        //     const stackString = stackframes
        //         .splice(0, 20)
        //         .map(function (sf) {
        //             return sf.toString();
        //         }).join('\n');
        //     // log on the server

        //     loggingService.log({ message, url, stack: stackString });
        // });

    }

    private showApiErrorInConsole(apiError: ApiError): void {
        if (console && console.group && console.error) {
            console.group("Api Error Group");
            console.error(apiError);
            console.error(apiError.message);
            if (apiError.errors)
                console.error(apiError.errors);
            if (apiError.detail)
                console.error(apiError.detail);
            if (apiError.stack)
                console.error(apiError.stack);
            console.groupEnd();
        }
    }

    private showErrorInConsole(error: any): void {
        if (console && console.group && console.error) {
            console.group("Error Group");
            console.error(error);
            console.groupEnd();
        }
    }

    // private parseError(error: any): ApiError {
    //     const unexpectedErrorMessage = 'Hmm.. Something went wrong. Try again shortly or call us at 210-477-4714';
    //     var statusCode = error.status ? error.status : 0;

    //     if (statusCode > 0) {
    //         let apiError = error.json() || {};  *******
    //         if (apiError.Message) {
    //             return { message: apiError.Message, isError: true };
    //         }

    //         apiError = <ApiError>(error.json() || {});
    //         return apiError;
    //     }
    //     return { message: unexpectedErrorMessage, isError: true };
    // }

    private parseError(error: any): ApiError {
        const unexpectedErrorMessage = 'Hmm.. Something went wrong. Try again shortly or call us at 210-477-4714';
        var statusCode = error.status ? error.status : 0;

        try {

            if (statusCode > 0) {

                let apiError = <ApiError>error.error;
                if (apiError.message) {
                    return { message: apiError.message, isError: true };
                }
                apiError = <ApiError>(error.json() || {});
                return apiError;

                // let apiError = error.json() || {};
                // let apiError = error.json() || {};
                // if (apiError.Message) {
                //     return { message: apiError.Message, isError: true };
                // }

                // apiError = <ApiError>(error.json() || {});
                // return apiError;
            }
            return { message: unexpectedErrorMessage, isError: true };
        } catch (e) {
            return { message: unexpectedErrorMessage, isError: true };
        }
            
    }


}
export interface ApiError {
    message: string,
    isError: boolean,

    errors?: ValidationError[];

    detail?: string,
    stack?: string
}

export interface ValidationError {
    errorMessage: string,
    controlName: string,
    errorCode: string
}


// WEBPACK FOOTER //
// ./src/app/core/handlers/global-error.handler.ts